import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of, zip } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { ConfigService } from '../../services/config.service';
import { GtmService } from '../../services/gtm.service';
import { InstanaService } from '../../services/instana.service';
import { TranslationConfigService } from '../../services/translation-config.service';
import { PurchasesService } from './services/purchases.service';
import { Me, UsersService } from './services/users.service';

@Injectable()
export class SelfServiceResolver {
    constructor(
        private readonly usersService: UsersService,
        private readonly purchasesService: PurchasesService,
        private configService: ConfigService,
        private translationConfigService: TranslationConfigService,
        private router: Router,
        private instana: InstanaService,
        private gtmService: GtmService,
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Me> {
        return this.usersService.getMe(['identity', 'sales', 'roles']).pipe(
            switchMap((me) => {
                const identityType = me.properties.find((property) => property.name === 'IdentityType')?.value || '';
                this.gtmService.pushUserProfile(identityType, me.id);

                if (identityType !== 'EK') {
                    // Fetch subscriptions only for end customer
                    return zip(of(me), of([]));
                }

                return zip(
                    of(me),
                    this.purchasesService.getSubscriptions(me.id).pipe(
                        catchError(() => {
                            return of([]);
                        }),
                    ),
                );
            }),
            tap((userData) => {
                const me = userData[0];
                const subscriptions = userData[1];

                this.instana.reportUserAndMeta(me);

                this.configService.me = me;
                this.configService.enablePurchasesAndSubscriptions = subscriptions.length > 0;
                this.translationConfigService.setLanguage(me.locale);
            }),
            catchError((error) => {
                this.router.navigate(['/incorrect-customer-data']);
                return of(error);
            }),
        );
    }
}
